import React, { useContext, useMemo } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import AudioModal from '../AudioModal';
import { AuthContext } from '../../context/Auth/AuthContext';
import {
  getInternalChatMediaKind,
  resolveInternalChatMediaFetchPath,
  resolveParticipantAvatarUrl,
} from '../../utils/internalChatMedia';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    minWidth: 240,
    maxWidth: 300,
    marginTop: 4,
  },
  shellMine: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    minWidth: 240,
    maxWidth: 300,
    padding: '4px 2px 0',
  },
  shellTheirs: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: 240,
    maxWidth: 300,
    padding: '4px 2px 0',
  },
}));

/**
 * Nota de voz do chat interno: mesmo player que o módulo WhatsApp (`AudioModal` em MessagesList),
 * com avatar + play + barra + tempo (fetch autenticado via path relativo).
 */
export default function InternalChatVoiceNote({ mediaPath, mediaName, speakerName, mine, sender }) {
  const classes = useStyles();
  const { user } = useContext(AuthContext);

  const avatarUrl = useMemo(() => {
    const rawAvatar = mine
      ? (user?.profilePicUrl ??
        user?.profileImage ??
        (typeof localStorage !== 'undefined' ? localStorage.getItem('profileImage') : null))
      : (sender?.profilePicUrl ?? sender?.profileImage ?? sender?.urlPicture);
    return resolveParticipantAvatarUrl(rawAvatar, user?.companyId);
  }, [mine, sender, user?.companyId, user?.profileImage, user?.profilePicUrl]);

  const raw = mediaPath || mediaName;
  if (!raw) return null;

  const fetchPath = resolveInternalChatMediaFetchPath(mediaPath || mediaName);
  if (!fetchPath) return null;

  const kind = getInternalChatMediaKind(mediaPath, mediaName);
  if (kind !== 'audio') return null;

  const who = typeof speakerName === 'string' && speakerName.trim() ? speakerName.trim() : ' ';

  return (
    <Box className={`${classes.root} ${mine ? classes.shellMine : classes.shellTheirs}`}>
      <AudioModal
        url={fetchPath}
        avatarUrl={avatarUrl || ''}
        userName={who}
        bubbleTone={mine ? 'outgoing' : 'incoming'}
      />
    </Box>
  );
}
